import { createSelector } from 'reselect';
import type { AppState } from '../../../types/State';
import type { UserProfileState } from '../reducers/userProfileReducer';

export const getUserProfileState = (state: AppState): UserProfileState => state.userProfile;

export const isProfileFetched = createSelector([getUserProfileState], state => state.isFetched);
export const isUpdating = createSelector([getUserProfileState], state => state.updating);
export const hasError = createSelector([getUserProfileState], state => state.error);
export const hasConfirmEmailError = createSelector([getUserProfileState], state => state.confirmEmailError);
export const hasEditEmailError = createSelector([getUserProfileState], state => state.editEmailError);
export const hasEditPasswordError = createSelector([getUserProfileState], state => state.editPasswordError);
export const getUserProfile = createSelector([getUserProfileState], state => state.userProfile);
export const getUserEmail = createSelector([getUserProfileState], state => state.userEmail);



// WEBPACK FOOTER //
// ./src/statsradio/modules/userProfile/selector/userProfileSelector.js